import { SVGProps } from 'react';

const ArrowBigLeftDash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20 9v6m-7-6a1 1 0 0 1-1-1V5.06a1 1 0 0 0-1.811-.75l-6.835 6.837a1.207 1.207 0 0 0 0 1.707l6.835 6.835a1 1 0 0 0 1.811-.75v-2.94a1 1 0 0 1 1-1h2a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z"
    />
  </svg>
);
export default ArrowBigLeftDash;
